import React from 'react';

interface StatuteArticleModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const StatuteArticleModal: React.FC<StatuteArticleModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        {/* Overlay */}
        <div 
          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" 
          aria-hidden="true"
          onClick={onClose}
        ></div>

        {/* Center modal */}
        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

        {/* Modal panel */}
        <div className="inline-block align-bottom bg-white dark:bg-gray-800 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-3xl sm:w-full">
          <div className="bg-white dark:bg-gray-800 px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div className="sm:flex sm:items-start">
              <div className="mt-3 text-center sm:mt-0 sm:text-left w-full">
                <h3 className="text-2xl leading-6 font-bold text-gray-900 dark:text-white mb-4" id="modal-title">
                  📋 Art. 4.1.1 dello Statuto UNASCA
                </h3>
                
                <div className="mt-4 text-sm text-gray-700 dark:text-gray-300 space-y-4 max-h-[60vh] overflow-y-auto pr-2">
                  <p className="font-semibold text-base">
                    Possono essere Associate, secondo quanto stabilito dal Regolamento:
                  </p>
                  
                  <ol className="list-decimal ml-6 space-y-2">
                    <li>le imprese esercenti l'attività di autoscuola e/o scuola nautica;</li>
                    <li>le imprese esercenti l'attività di consulenza per la circolazione dei mezzi di trasporto.</li>
                  </ol>

                  <p>
                    La domanda di iscrizione deve essere sottoscritta dal titolare, dal legale rappresentante dell'impresa 
                    o dall'institore e deve essere presentata, secondo quanto indicato nel regolamento, alla Segreteria 
                    Provinciale o al Fiduciario di settore competente per territorio o, in mancanza di questi, inoltrata 
                    direttamente al Comitato di Presidenza e di Coordinamento.
                  </p>

                  <p>
                    Non può essere iscritta o rimanere iscritta all'Associazione UNASCA un'impresa che faccia parte di 
                    altra associazione, ente od organismo che persegua finalità o interessi ritenuti contrastanti con 
                    quelli di UNASCA.
                  </p>

                  <p>
                    L'iscrizione deve essere rifiutata, secondo le modalità stabilite nel regolamento, con provvedimento 
                    motivato qualora l'impresa incorra in uno dei casi di cui all'articolo 5.1 o qualora in contrasto con 
                    l'articolo 3 o con il codice Etico o il codice Deontologico di settore.
                  </p>

                  <p>
                    La Segreteria Provinciale di settore, salve le previsioni di cui all'articolo 4.1.2, deve esaminare 
                    la domanda, verificare il possesso dei requisiti e comunicare l'esito all'impresa interessata entro 
                    30 (trenta) giorni dal ricevimento della domanda di iscrizione. La Segreteria Provinciale decide con 
                    deliberazione ai sensi dell'art.8.2 del presente Statuto, salve le previsioni di cui all'articolo 4.1.2
                  </p>

                  <p>
                    Nello stesso modo procede il Comitato di Presidenza e di Coordinamento per gli altri casi.
                  </p>

                  <p className="font-semibold">
                    La rappresentanza ai fini associativi ed i relativi requisiti minimi di partecipazione sono disciplinati 
                    secondo quanto indicato nel regolamento.
                  </p>

                  <div className="mt-6 pt-4 border-t border-gray-200 dark:border-gray-700">
                    <a
                      href="https://unasca.it/PDF/STATUTO_UNASCA2023.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-300 font-medium"
                    >
                      <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                      Scarica lo Statuto UNASCA completo (PDF)
                    </a>
                  </div>
                  <div className="mt-6 pt-4 border-t border-gray-200 dark:border-gray-700">
                    <a
                      href="https://unasca.it/PDF/REGOLAMENTO_ALLO_STATUTO2024.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-300 font-medium"
                    >
                      <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                      Scarica il Regolamento allo Statuto UNASCA (PDF)
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="bg-gray-50 dark:bg-gray-700 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <button
              type="button"
              onClick={onClose}
              className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-600 text-base font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:ml-3 sm:w-auto sm:text-sm"
            >
              Chiudi
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatuteArticleModal;

